import React, {
  useState,
  useEffect,
  useContext,
  useLayoutEffect,
  useMemo,
} from "react";
import { AuthContext } from "../../contexts/AuthContext";
import axios from "axios";
import Header from "../../layout/Header/Header";

import { Row, Input, Col } from "reactstrap";
import moment from "moment";
import Swal from "sweetalert2";
import {
  DashPage,
  FilterBar,
  Filtro,
  FiltroSeparador,
  BotonActualizar,
  KpiRow,
  DashCard,
  ChartBox,
  montarGraficas,
  graficaDona,
} from "./dashboardUI";

function DashboardCompras() {
  const { user } = useContext(AuthContext);
  const URL_DASHBOARDS = process.env.REACT_APP_URL_DASHBOARDS;

  let hoy = new Date();
  let inicio = new Date();
  inicio.setDate(inicio.getDate() - 90);


  let endDate = moment(hoy).format("YYYY-MM-DD");
  let startDate = moment(inicio).format("YYYY-MM-DD");


  const [info, setInfo] = useState([]);
  const [graficasUnidadesNegocio, setGraficasUnidadesNegocio] = useState([]);
  const [graficasLineas, setGraficasLineas] = useState([]);
  const [graficasProveedores, setGraficasProveedores] = useState([]);
  const [graficasFamilias, setGraficasFamilias] = useState([]);
  const [graficasMeses, setGraficasMeses] = useState([]);
  const [valorComprado, setValorComprado] = useState(0);
  const [cantidadComprado, setcantidadComprado] = useState(0);

  const [unidadesNegocio, setUnidadesNegocio] = useState([]);
  const [familias, setFamilias] = useState([]);
  const [lineas, setLineas] = useState([]);
  const [meses, setMeses] = useState([]);
  const [proveedores, setProveedores] = useState([]);
  const [selectedUnidadNegocio, setSelectedUnidadNegocio] = useState("");
  const [selectedFamilia, setSelectedFamilia] = useState("");
  const [selectedLinea, setSelectedLinea] = useState("");
  const [selectedProveedor, setSelectedProveedor] = useState("");
  const [selectedMes, setSelectedMes] = useState("");

  const [selectedFechaInicio, setSelectedFechaInicio] = useState(startDate);
  const [selectedFechaFin, setSelectedFechaFin] = useState(endDate);

  const [cargando, setCargando] = useState(true);

  const Toast = Swal.mixin({
    toast: true,
    position: "center",
    showConfirmButton: false,
    // timer: 5000,
    timerProgressBar: true,
    didOpen: (toast) => {
      toast.addEventListener("mouseenter", Swal.stopTimer);
      toast.addEventListener("mouseleave", Swal.resumeTimer);
    },
  });

  if (cargando) {
    Toast.fire({
      html: `<i class="fas fa-hourglass-half custom-spin fa-2x" style="margin-right: 16px;"></i>`, // Ícono de carga animado
      title: "Danos unos segundos....",
      customClass: {
        icon: 'animated-icon'
      }
    });
  }

useEffect(()=>{
  axios
  .get(`${URL_DASHBOARDS}Compras/${selectedFechaInicio}/${selectedFechaFin}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allDisponible = response.data;

      setInfo(allDisponible)

      let unicosCol = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idUnidadNegocio === value.idUnidadNegocio)
      );
      setUnidadesNegocio(unicosCol);

      let unicosFam = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idFamilia === value.idFamilia)
      );
      setFamilias(unicosFam);

      let unicosLin = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idLinea === value.idLinea)
      );
      setLineas(unicosLin);

      let unicosProv = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idProveedor === value.idProveedor)
      );
      setProveedores(unicosProv);

      let unicosMes = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.Mes === value.Mes)
      );
      setMeses(unicosMes);
      
      setCargando(false);
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
    });

},[])


function BuscaInfo(){
  setInfo([])
  setSelectedUnidadNegocio("")
  setSelectedFamilia("")
  setSelectedLinea("")
  setSelectedLinea("")
  setSelectedProveedor("")
  setSelectedMes("")
  setCargando(true)
  axios
  .get(`${URL_DASHBOARDS}Compras/${selectedFechaInicio}/${selectedFechaFin}`, {
    headers: {
      Authorization: `Bearer: ${localStorage.getItem("app_token")}`,
    },
  })
  .then((response) => {
    let allDisponible = response.data;

      setInfo(allDisponible)

      let unicosCol = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idUnidadNegocio === value.idUnidadNegocio)
      );
      setUnidadesNegocio(unicosCol);

      let unicosFam = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idFamilia === value.idFamilia)
      );
      setFamilias(unicosFam);

      let unicosLin = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idLinea === value.idLinea)
      );
      setLineas(unicosLin);

      let unicosProv = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.idProveedor === value.idProveedor)
      );
      setProveedores(unicosProv);

      let unicosMes = allDisponible.filter(
        (value, index, self) =>
          index === self.findIndex((t) => t.Mes === value.Mes)
      );
      setMeses(unicosMes);
      
      setCargando(false);
      Toast.close();
    })
    .catch((err) => {
      console.log(err);
    });
}

  useMemo(() => {
      let temp = info
          if (selectedMes) {
            temp = temp.filter((e) =>
              e.Mes.includes(selectedMes)
            );
          }
          if (selectedUnidadNegocio) {
            temp = temp.filter((e) =>
              e.idUnidadNegocio.includes(selectedUnidadNegocio)
            );
          }
          if (selectedFamilia) {
            temp = temp.filter((e) =>
              e.idFamilia.includes(selectedFamilia)
            );
          }
          if (selectedLinea) {
            temp = temp.filter((e) =>
              e.idLinea.includes(selectedLinea)
            );
          }

          if (selectedProveedor) {
            temp = temp.filter((e) =>
              e.idProveedor.includes(selectedProveedor)
            );
          }

        let agrupadoUnidadNegocio = temp.reduce(function (groups, item) {
          const val = item["idUnidadNegocio"];
          groups[val] = groups[val] || {
            idUnidadNegocio: item.idUnidadNegocio,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].unidadNegocio = item.unidadNegocio;
          groups[val].idUnidadNegocio = item.idUnidadNegocio;
          return groups;
        }, []);

        let otraUnidadNegocio = Object.values(agrupadoUnidadNegocio).sort((a, b) =>
          a.cantidad < b.cantidad ? 1 : -1
        );

        setGraficasUnidadesNegocio(otraUnidadNegocio);

        let agrupadoLinea = temp.reduce(function (groups, item) {
          const val = item["idLinea"];
          groups[val] = groups[val] || {
            idLinea: item.idLinea,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].linea = item.linea;
          groups[val].idLinea = item.idLinea;
          return groups;
        }, []);

        let otraLinea = Object.values(agrupadoLinea).sort((a, b) =>
          a.cantidad < b.cantidad ? 1 : -1
        );

        setGraficasLineas(otraLinea);

        let agrupadoFamilia = temp.reduce(function (groups, item) {
          const val = item["idFamilia"];
          groups[val] = groups[val] || {
            idFamilia: item.idFamilia,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].familia = item.familia;
          groups[val].idFamilia = item.idFamilia;
          return groups;
        }, []);

        let otraFamilia = Object.values(agrupadoFamilia).sort((a, b) =>
          a.cantidad < b.cantidad ? 1 : -1
        );

        setGraficasFamilias(otraFamilia);


        let agrupadoMes = temp.reduce(function (groups, item) {
          const val = item["Mes"];
          groups[val] = groups[val] || {
            Mes: item.Mes,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].Mes = item.Mes;
          return groups;
        }, []);

        let otraMes = Object.values(agrupadoMes).sort((a, b) =>
          a.cantidad < b.cantidad ? 1 : -1
        );

        setGraficasMeses(otraMes);


        let agrupadoProveedor = temp.reduce(function (groups, item) {
          const val = item["idProveedor"];
          groups[val] = groups[val] || {
            idProveedor: item.idProveedor,
            cantidad: 0,
          };
          groups[val].cantidad += item.cantidad;
          groups[val].proveedor = item.proveedor;
          groups[val].idProveedor = item.idProveedor;
          return groups;
        }, []);

        let otraProveedor = Object.values(agrupadoProveedor).sort((a, b) =>
          a.cantidad < b.cantidad ? 1 : -1
        );

        setGraficasProveedores(otraProveedor);

        let TVal = temp.map((c) => parseFloat(c.total));
        let TV = TVal.reduce((t, total, index) => t + total, 0);
        setValorComprado(TV);

        let TCan = temp.map((c) => parseFloat(c.cantidad));
        let TC = TCan.reduce((t, total, index) => t + total, 0);
        setcantidadComprado(TC);

  }, [info, selectedMes, selectedUnidadNegocio, selectedFamilia, selectedLinea, selectedProveedor]);


  useLayoutEffect(
    () =>
      montarGraficas([
        ["chartdivLineas", (root) => graficaDona(root, { data: graficasLineas, valor: "cantidad", categoria: "linea", sufijo: " pzs", centro: "Piezas" })],
        ["chartdivMeses", (root) => graficaDona(root, { data: graficasMeses, valor: "cantidad", categoria: "Mes", sufijo: " pzs", centro: "Piezas" })],
        ["chartdivProveedores", (root) => graficaDona(root, { data: graficasProveedores, valor: "cantidad", categoria: "proveedor", sufijo: " pzs", centro: "Piezas" })],
      ]),
    [graficasLineas, graficasMeses, graficasProveedores]
  );

  const kpis = [
    { label: "Compras $", value: valorComprado, formato: "moneda", icon: "fas fa-dollar-sign", color: "#3b82f6" },
    { label: "Piezas", value: cantidadComprado, formato: "numero", icon: "fas fa-boxes", color: "#10b981" },
    { label: "Proveedores", value: graficasProveedores.length, formato: "entero", icon: "fas fa-truck", color: "#f59e0b" },
    { label: "Líneas", value: graficasLineas.length, formato: "entero", icon: "fas fa-tags", color: "#8b5cf6" },
  ];

  return (
    <>
      <Header />
      {/* {user.menu_cantidad ? ( */}
      <DashPage
        icon="fas fa-cart-plus"
        color="#3b82f6"
        bg="#eff6ff"
        title="Dashboard Compras"
        subtitle="Piezas e importe comprado por línea, mes y proveedor"
        cargando={cargando}
      >
        <FilterBar>
          <Filtro label="Fecha inicio" chico>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaInicio}
              onChange={(e) => {
                setSelectedFechaInicio(e.target.value)
              }}
            />
          </Filtro>
          <Filtro label="Fecha fin" chico>
            <Input
              bsSize="sm"
              type="date"
              value={selectedFechaFin}
              onChange={(e) => {
                setSelectedFechaFin(e.target.value)
              }}
            />
          </Filtro>
          <BotonActualizar onClick={BuscaInfo} cargando={cargando} />

          <FiltroSeparador />

          <Filtro label="Mes">
            <Input
              bsSize="sm"
              type="select"
              value={selectedMes}
              onChange={(e) => {
                setSelectedMes(e.target.value);
              }}
            >
              <option value="">Todos</option>
              {meses
                // .sort((a, b) => (a.Mes > b.Mes ? 1 : -1))
                .map((a) => {
                  return <option key={a.Mes} value={a.Mes}>{a.Mes}</option>;
                })}
            </Input>
          </Filtro>

          <Filtro label="Línea">
            <Input
              bsSize="sm"
              type="select"
              value={selectedLinea}
              onChange={(e) => {
                setSelectedLinea(e.target.value);
              }}
            >
              <option value="">Todas</option>
              {lineas
                .sort((a, b) => (a.linea > b.linea ? 1 : -1))
                .map((a) => {
                  return <option key={a.idLinea} value={a.idLinea}>{a.linea}</option>;
                })}
            </Input>
          </Filtro>

          <Filtro label="Proveedor">
            <Input
              bsSize="sm"
              type="select"
              value={selectedProveedor}
              onChange={(e) => {
                setSelectedProveedor(e.target.value);
              }}
            >
              <option value="">Todos</option>
              {proveedores
                .sort((a, b) => (a.proveedor > b.proveedor ? 1 : -1))
                .map((a) => {
                  return <option key={a.idProveedor} value={a.idProveedor}>{a.proveedor}</option>;
                })}
            </Input>
          </Filtro>
        </FilterBar>

        <KpiRow items={kpis} />

        <Row className="dash-row">
          <Col lg={6}>
            <DashCard icon="fas fa-tags" color="#8b5cf6" title="Piezas por línea" subtitle="Piezas compradas y % del total">
              <ChartBox id="chartdivLineas" height={320} cargando={cargando} vacio={graficasLineas.length === 0} />
            </DashCard>
          </Col>
          <Col lg={6}>
            <DashCard icon="fas fa-calendar-alt" color="#10b981" title="Piezas por mes" subtitle="Piezas compradas y % del total">
              <ChartBox id="chartdivMeses" height={320} cargando={cargando} vacio={graficasMeses.length === 0} />
            </DashCard>
          </Col>
        </Row>

        <Row className="dash-row">
          <Col md={12}>
            <DashCard icon="fas fa-truck" color="#f59e0b" title="Piezas por proveedor" subtitle="Piezas compradas y % del total">
              <ChartBox id="chartdivProveedores" height={340} cargando={cargando} vacio={graficasProveedores.length === 0} />
            </DashCard>
          </Col>
        </Row>
      </DashPage>
      {/* ) : undefined}  */}
    </>
  );
}
export default DashboardCompras;
